import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import axios from 'axios';
import NavHeader from '../shared/Nav-Header';
import ChatBox from '../shared/ChatBox'; // Import the ChatBox component
import JobChatBox from '../shared/JobChatBox'; // Import the ChatBox component
import styles from './messages.module.css'; // Use CSS modules

const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-e45c.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true // Important for CORS with credentials
});


const MessagesRecruiterPage = ({ roomId }) => {
    const [messages, setMessages] = useState([]);
    const [recentMessage, setRecentMessage] = useState('');
    const [applicants, setApplicants] = useState([]);
    const [applicantIds, setApplicantIds] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [userId1, setUserId1] = useState(null);
    const [userId, setUserId] = useState('');
    const [activeChat, setActiveChat] = useState(null);
    const [currentRoomId, setCurrentRoomId] = useState(null);
    const [showOptions, setShowOptions] = useState(null);
    const [showReadBy, setShowReadBy] = useState(null);
    const [chatBoxPosition, setChatBoxPosition] = useState({ right: 10, bottom: 20 });
    const navigate = useNavigate();
    const bottomRef = useRef(null);
    const chatBoxRef = useRef(null);
    const [selectedApplicant, setSelectedApplicant] = useState(null);
    const [selectedJob, setSelectedJob] = useState(null);
    const [showChatBox, setShowChatBox] = useState(false); // State to control chat-box visibility
    const [showJobChatBox, setShowJobChatBox] = useState(false); // State to control chat-box visibility
    const [applicationData, setApplicationData] = useState(null);
    const [headPage,setHeadPage] = useState('');
    
    

    useEffect(() => {
        const savedPosition = JSON.parse(localStorage.getItem('chatBoxPosition'));
        if (savedPosition) {
            setChatBoxPosition(savedPosition);
        }
    }, []);

    useEffect(() => {
            const fetchApplicantList = async () => {
                try {
                    const token = localStorage.getItem('token');
                    const response = await axios.get('/api/recruiter-to-applicant-message/all-applicants', {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setApplicants(response.data.applicants);
                    // console.log('response.data.applicants:', response.data.applicants);
                    setUserId1(response.data.userId);
                } catch (error) {
                    console.error('Error fetching Applicant List:', error);
                }
            };
    
            fetchApplicantList();
            setHeadPage('Messages');
    }, []);

    useEffect(() => {
            const fetchJobLists = async () => {
                try {
                    const token = localStorage.getItem('token');
                    const response = await axios.get('/api/recruiter-to-applicants-message/job-applicants', {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    // console.log('response.data.applicants:', response.data.jobs.applicants);
                    // console.log('response.data:', response.data.jobs);
                    setJobs(response.data.jobs);

                    const applicantIds = response.data.jobs
                    .map(applicant => applicant.applicantId?._id) // Use optional chaining to safely access _id
                    .filter(id => id !== null && id !== undefined); // Filter out null or undefined IDs
                     setApplicantIds(applicantIds);
                } catch (error) {
                    console.error('Error fetching Job List:', error);
                }
            };
            fetchJobLists();
    }, []);

    const handleSendMessage = ( applicantId, applicantName, applicantProfilePicture) => {
        setSelectedApplicant({ applicantId, applicantName, applicantProfilePicture });
        setShowJobChatBox(false);
        setShowChatBox(true);
    };
    const handleSendJobMessage = (jobId, jobTitle) => {
        setSelectedJob({ jobId, jobTitle });
        setShowChatBox(false);
        setShowJobChatBox(true);
    };

    return (
        <>
        <NavHeader />
            <div className={styles.chatContainer}>
                <div className={styles.projectNetworksList}>
                    <h3>Applicants Messaged</h3>
                    <ul>
                        {applicants.map((applicant) => (
                            <li key={applicant._id} onClick={() => handleSendMessage(applicant._id, applicant.name, applicant.profilePicture)}>
                                <img 
                                title={applicant.name}
                                src={applicant.profilePicture ? applicant.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                                alt="Profile" className={styles.profilePicture} />
                                {applicant.name}
                            </li>
                        ))}
                    </ul>
                    {showChatBox && (
                        <ChatBox
                        recipientId={selectedApplicant.applicantId}
                        recipientName={selectedApplicant.applicantName}
                        onClose={() => setShowChatBox(false)}
                        headPage={headPage}
                        {...(headPage === 'Messages' && { imgSrc : selectedApplicant.applicantProfilePicture })} 
                        />
                    )}
                </div>         
                </div>
                <div className={styles.chatContainer}>
                <div className={styles.jobsList}>
                    <h3>Job Applicants Messaged</h3>
                    <ul>
                        {jobs.map((job) => (
                            <li key={job._id} onClick={() => handleSendJobMessage(job._id, job.title)}>
                                {job.title}
                                <span className={styles.applicationCount}>Applied Applicants: {job.applicationCount}</span>
                            </li>
                        ))}
                    </ul>
                    {showJobChatBox && (
                        <JobChatBox
                        jobTitle={selectedJob.jobTitle}
                        jobId={selectedJob.jobId}
                        applicantIds={applicantIds}
                        onClose={() => setShowJobChatBox(false)}
                        />
                    )}
                </div>  
                <div className={styles.recipientArea}>
                    <h3>Change Chat Recipient</h3>
                </div>
            </div>
        </>
    );
}

export default MessagesRecruiterPage;